module.exports = __webpack_public_path__ + "a388600233582de97d804641d8a9d4fd.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/bg.png
// module id = ./app/images/bg.png
// module chunks = 40